const STORE_ID = "ROUTES";

const TYPES = {
    SET_ROUTES: 'SET_ROUTES',
    CLEAN_ROUTES: "CLEAN_ROUTES",
}

export { STORE_ID, TYPES }